/* ============================================================
   OLØR — Theme JavaScript
   ============================================================ */

(function() {
  'use strict';

  /* ─── Helpers ─── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const off = (el, ev, fn) => el && el.removeEventListener(ev, fn);

  /* ─── Header scroll ─── */
  (function initHeader() {
    const header = $('.site-header');
    if (!header) return;

    const announcementBar = $('.announcement-bar');
    if (announcementBar) {
      document.documentElement.style.setProperty(
        '--announcement-height', announcementBar.offsetHeight + 'px'
      );
    }

    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 20);
      lastY = y;
    };

    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ─── Mobile nav ─── */
  (function initMobileNav() {
    const hamburger = $('.header-hamburger');
    const nav = $('.mobile-nav');
    const overlay = $('#overlay');
    if (!hamburger || !nav) return;

    const close = () => {
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      nav.classList.remove('open');
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    const open = () => {
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      nav.classList.add('open');
      overlay && overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    on(hamburger, 'click', () => {
      nav.classList.contains('open') ? close() : open();
    });

    on(overlay, 'click', close);

    on(document, 'keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  })();

  /* ─── Cart drawer ─── */
  (function initCartDrawer() {
    const drawer = $('.cart-drawer');
    const overlay = $('#overlay');
    if (!drawer) return;

    const open = () => {
      drawer.classList.add('open');
      overlay && overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
    };

    const close = () => {
      drawer.classList.remove('open');
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
    };

    on(overlay, 'click', close);

    $$('[data-cart-open]').forEach(btn => on(btn, 'click', open));
    $$('[data-cart-close]').forEach(btn => on(btn, 'click', close));

    on(document, 'keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    window.CartDrawer = { open, close };
  })();

  /* ─── Cart AJAX ─── */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    return res.json();
  }

  async function addToCart(variantId, quantity = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function updateCartItem(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return res.json();
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('visible', count > 0);
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  }

  async function refreshCartDrawer() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    renderCartItems(cart);
  }

  function renderCartItems(cart) {
    const body = $('.cart-drawer-body');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.25">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          <p class="cart-empty-text">Your cart is empty</p>
          <a href="/collections/all" class="btn btn--primary" data-cart-close>Shop Now</a>
        </div>`;
      return;
    }

    const items = cart.items.map((item, i) => `
      <div class="cart-item" data-line="${i + 1}">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image.replace('.jpg', '_120x150.jpg')}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-details">
          <div class="cart-item-name">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-row">
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item-qty">
              <button class="qty-btn" data-qty-change="-1" data-line="${i + 1}" aria-label="Decrease quantity">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn" data-qty-change="+1" data-line="${i + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>
      </div>`).join('');

    const subtotal = `
      <div class="cart-drawer-footer">
        <div class="cart-subtotal">
          <span class="cart-subtotal-label">Subtotal</span>
          <span class="cart-subtotal-price">${formatMoney(cart.total_price)}</span>
        </div>
        <p class="cart-taxes">Taxes and shipping calculated at checkout</p>
        <a href="/checkout" class="btn btn--primary btn--full">Proceed to Checkout</a>
        <a href="/cart" class="btn btn--secondary btn--full">View Cart</a>
      </div>`;

    body.innerHTML = `<div class="cart-items">${items}</div>`;
    body.insertAdjacentHTML('afterend', subtotal);

    $$('[data-qty-change]', body).forEach(btn => {
      on(btn, 'click', async () => {
        const line = parseInt(btn.dataset.line);
        const delta = parseInt(btn.dataset.qtyChange);
        const item = cart.items[line - 1];
        if (!item) return;
        const newQty = Math.max(0, item.quantity + delta);
        await updateCartItem(line, newQty);
        refreshCartDrawer();
      });
    });
  }

  /* ─── Add to cart form ─── */
  (function initProductForm() {
    const forms = $$('[data-product-form]');
    forms.forEach(form => {
      on(form, 'submit', async (e) => {
        e.preventDefault();
        const btn = $('[data-atc-btn]', form) || $('[type="submit"]', form);
        const variantInput = $('[name="id"]', form);
        if (!variantInput) return;

        const originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        try {
          await addToCart(parseInt(variantInput.value), 1);
          btn.textContent = 'Added';
          await refreshCartDrawer();
          window.CartDrawer && window.CartDrawer.open();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } catch (err) {
          btn.textContent = 'Sold Out';
          btn.disabled = false;
        }
      });
    });
  })();

  /* ─── Scroll reveal ─── */
  (function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('[data-reveal]').forEach(el => el.classList.add('revealed'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    $$('[data-reveal]').forEach(el => observer.observe(el));
  })();

  /* ─── Hero load animation ─── */
  (function initHero() {
    const hero = $('.hero');
    if (!hero) return;
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('loaded'), 100);
    });
  })();

  /* ─── Product gallery ─── */
  (function initProductGallery() {
    const gallery = $('.product-gallery');
    if (!gallery) return;

    const mainImg = $('.product-gallery-main img', gallery);
    const thumbs = $$('.gallery-thumb', gallery);

    thumbs.forEach((thumb, i) => {
      on(thumb, 'click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        if (mainImg && src) {
          mainImg.style.opacity = '0';
          mainImg.style.transform = 'scale(0.97)';
          setTimeout(() => {
            mainImg.src = src;
            mainImg.srcset = '';
            mainImg.style.opacity = '1';
            mainImg.style.transform = 'scale(1)';
          }, 200);
        }
      });
    });

    // Zoom modal
    const mainWrap = $('.product-gallery-main', gallery);
    const modal = $('.zoom-modal');
    const zoomImg = modal && $('img', modal);

    on(mainWrap, 'click', () => {
      if (!modal || !mainImg) return;
      zoomImg && (zoomImg.src = mainImg.src);
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    on(modal, 'click', () => {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    });
  })();

  /* ─── Variant selection ─── */
  (function initVariants() {
    const productForms = $$('[data-product-form]');
    productForms.forEach(form => {
      const variantInput = $('[name="id"]', form);
      const priceEl = $('[data-product-price]');
      const comparePriceEl = $('[data-product-compare-price]');
      const addBtn = $('[data-atc-btn]', form);
      const selectedVariantLabel = $('[data-variant-selected]', form);

      const productData = JSON.parse($('[data-product-json]', form)?.textContent || '{}');
      const variants = productData.variants || [];

      $$('[data-option-btn]', form).forEach(btn => {
        on(btn, 'click', () => {
          const option = btn.dataset.option;
          const value = btn.dataset.value;

          $$(`[data-option="${option}"]`, form).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          const selected = {};
          $$('[data-option-btn].active', form).forEach(b => {
            selected[b.dataset.option] = b.dataset.value;
          });

          const matched = variants.find(v =>
            v.options.every((opt, i) => opt === selected[`option${i + 1}`])
          );

          if (matched) {
            variantInput.value = matched.id;
            if (priceEl) priceEl.textContent = formatMoney(matched.price);
            if (comparePriceEl) {
              comparePriceEl.textContent = matched.compare_at_price ? formatMoney(matched.compare_at_price) : '';
              comparePriceEl.hidden = !matched.compare_at_price;
            }
            if (addBtn) {
              addBtn.disabled = !matched.available;
              addBtn.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
            }
          }
        });
      });

      $$('[data-swatch-btn]', form).forEach(btn => {
        on(btn, 'click', () => {
          $$('[data-swatch-btn]', form).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          if (selectedVariantLabel) selectedVariantLabel.textContent = btn.dataset.value;

          const hiddenBtn = $(`[data-option-btn][data-value="${btn.dataset.value}"]`, form);
          hiddenBtn && hiddenBtn.click();
        });
      });
    });
  })();

  /* ─── Quantity selector ─── */
  (function initQtySelectors() {
    $$('.quantity-selector').forEach(sel => {
      const input = $('input', sel);
      const minus = $('[data-qty="-"]', sel);
      const plus  = $('[data-qty="+"]', sel);
      if (!input) return;

      on(minus, 'click', () => {
        const val = parseInt(input.value) - 1;
        input.value = Math.max(1, val);
      });

      on(plus, 'click', () => {
        input.value = parseInt(input.value) + 1;
      });
    });
  })();

  /* ─── Sticky ATC ─── */
  (function initStickyATC() {
    const atcSection = $('.product-add-section');
    const stickyBar = $('.sticky-atc');
    if (!atcSection || !stickyBar) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(atcSection);
  })();

  /* ─── FAQ / Accordion ─── */
  (function initAccordions() {
    $$('.accordion-trigger').forEach(trigger => {
      const content = trigger.nextElementSibling;
      if (!content) return;

      on(trigger, 'click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        $$('.accordion-trigger[aria-expanded="true"]').forEach(t => {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            const c = t.nextElementSibling;
            if (c) c.style.height = '0';
          }
        });

        trigger.setAttribute('aria-expanded', String(!isOpen));
        content.style.height = isOpen ? '0' : content.scrollHeight + 'px';
      });
    });
  })();

  /* ─── Drag scroll (showcase) ─── */
  (function initDragScroll() {
    $$('.showcase-track-wrap').forEach(wrap => {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      on(wrap, 'mousedown', (e) => {
        isDown = true;
        wrap.classList.add('grabbing');
        startX = e.pageX - wrap.offsetLeft;
        scrollLeft = wrap.scrollLeft;
      });

      on(wrap, 'mouseleave', () => { isDown = false; wrap.classList.remove('grabbing'); });
      on(wrap, 'mouseup',    () => { isDown = false; wrap.classList.remove('grabbing'); });

      on(wrap, 'mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - wrap.offsetLeft;
        const walk = (x - startX) * 1.5;
        wrap.scrollLeft = scrollLeft - walk;
      });
    });
  })();

  /* ─── Gallery touch swipe (mobile) ─── */
  (function initSwipe() {
    const gallery = $('.product-gallery-main');
    if (!gallery) return;

    let startX = 0;
    const thumbs = $$('.gallery-thumb');
    let currentIndex = 0;

    on(gallery, 'touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });

    on(gallery, 'touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 50) return;
      if (diff > 0 && currentIndex < thumbs.length - 1) currentIndex++;
      else if (diff < 0 && currentIndex > 0) currentIndex--;
      thumbs[currentIndex] && thumbs[currentIndex].click();
    });
  })();

  /* ─── Smooth parallax (hero) ─── */
  (function initParallax() {
    const heroBg = $('.hero-bg img');
    if (!heroBg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const update = () => {
      const y = window.scrollY;
      if (y < window.innerHeight * 1.5) {
        heroBg.style.transform = `scale(1) translateY(${y * 0.25}px)`;
      }
    };

    on(window, 'scroll', update, { passive: true });
  })();

  /* ─── Color showcase placeholder ─── */
  (function initShowcasePlaceholders() {
    $$('.showcase-card-image').forEach(card => {
      if (!card.querySelector('img')) {
        const color = card.closest('.showcase-card')?.dataset.color || '#F5F2EC';
        card.style.background = color;
      }
    });
  })();

  /* ─── Init cart count on load ─── */
  fetchCart().then(cart => updateCartCount(cart.item_count)).catch(() => {});

  /* ─── Newsletter form ─── */
  (function initNewsletter() {
    $$('[data-newsletter-form]').forEach(form => {
      on(form, 'submit', async (e) => {
        e.preventDefault();
        const email = $('[type="email"]', form)?.value;
        const btn = $('[type="submit"]', form);
        if (!email || !btn) return;

        const original = btn.textContent;
        btn.textContent = '...';
        btn.disabled = true;

        // Klaviyo / Shopify newsletter — standard form POST
        const data = new FormData(form);
        try {
          await fetch('/contact#contact_form', { method: 'POST', body: data });
          btn.textContent = 'Subscribed';
          form.reset();
        } catch {
          btn.textContent = original;
          btn.disabled = false;
        }
      });
    });
  })();

  /* ─── Lifecycle page transition ─── */
  (function initPageTransition() {
    document.documentElement.style.opacity = '0';
    document.documentElement.style.transition = 'opacity 0.3s ease';
    on(window, 'load', () => {
      document.documentElement.style.opacity = '1';
    });
    $$('a[href]').forEach(a => {
      const href = a.getAttribute('href');
      if (!href.startsWith('#') && !href.startsWith('mailto:') && !href.startsWith('tel:')
          && !a.target && !href.includes('//') || href.includes(window.location.hostname)) {
        on(a, 'click', (e) => {
          if (e.metaKey || e.ctrlKey) return;
          const dest = a.href;
          if (dest === window.location.href) return;
          e.preventDefault();
          document.documentElement.style.opacity = '0';
          setTimeout(() => { window.location = dest; }, 260);
        });
      }
    });
  })();

  /* ─── Page scroll progress bar ─── */
  (function initPageProgress() {
    const bar = document.createElement('div');
    bar.className = 'page-progress';
    document.body.appendChild(bar);
    on(window, 'scroll', () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (window.scrollY / total * 100) + '%';
    }, { passive: true });
  })();

  /* ─── Word-by-word text reveal ─── */
  (function initTextReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    $$('[data-text-reveal]').forEach(el => {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';
      const raw = el.textContent.trim();
      const words = raw.split(/\s+/);
      el.innerHTML = words.map((w, i) =>
        `<span class="word-wrap"><span class="word" style="transition-delay:${(i * 0.055).toFixed(3)}s">${w}</span></span>`
      ).join(' ');
    });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });

    $$('[data-text-reveal]').forEach(el => obs.observe(el));
  })();

  /* ─── 3D tilt on cards ─── */
  (function initTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if ('ontouchstart' in window) return;

    $$('[data-tilt]').forEach(card => {
      let rafId;
      on(card, 'mousemove', (e) => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width - 0.5;
          const y = (e.clientY - rect.top) / rect.height - 0.5;
          card.style.transform =
            `perspective(900px) rotateX(${y * -10}deg) rotateY(${x * 10}deg) scale(1.025)`;
          card.style.transition = 'transform 0.08s linear';
        });
      });
      on(card, 'mouseleave', () => {
        cancelAnimationFrame(rafId);
        card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)';
        card.style.transition = 'transform 0.7s cubic-bezier(0.16,1,0.3,1)';
      });
    });
  })();

  /* ─── Sticky scroll features ─── */
  (function initStickyFeatures() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    $$('.scroll-features').forEach(section => {
      const slides     = $$('.scroll-feature-slide', section);
      const dots       = $$('.scroll-features-dot', section);
      const lineFill   = $('.scroll-features-line-fill', section);
      const counter    = $('.scroll-features-counter', section);
      if (!slides.length) return;

      const count = slides.length;
      section.style.minHeight = `${(count + 0.8) * 100}vh`;

      let currentIndex = -1;

      const update = () => {
        const rect   = section.getBoundingClientRect();
        const total  = section.offsetHeight - window.innerHeight;
        const prog   = Math.max(0, Math.min(1, -rect.top / total));
        const newIdx = Math.min(Math.floor(prog * count), count - 1);

        if (newIdx !== currentIndex) {
          const prev  = currentIndex;
          currentIndex = newIdx;

          slides.forEach((slide, i) => {
            slide.classList.remove('active', 'sf-exit-up', 'sf-exit-down');
            if (i === currentIndex) {
              slide.classList.add('active');
            } else if (i === prev) {
              slide.classList.add(newIdx > prev ? 'sf-exit-up' : 'sf-exit-down');
            }
          });

          dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
          if (counter) counter.textContent = `${currentIndex + 1} / ${count}`;
        }

        if (lineFill) lineFill.style.height = `${prog * 100}%`;
      };

      on(window, 'scroll', update, { passive: true });
      update();
    });
  })();

  /* ─── Animated number counters ─── */
  (function initCounters() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el     = entry.target;
        const target = parseFloat(el.dataset.count);
        const dur    = 1600;
        const start  = performance.now();
        const dec    = String(target).includes('.') ? 1 : 0;
        const tick   = (now) => {
          const t = Math.min((now - start) / dur, 1);
          const e = 1 - Math.pow(1 - t, 3);
          el.textContent = (e * target).toFixed(dec);
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        obs.unobserve(el);
      });
    }, { threshold: 0.6 });

    $$('[data-count]').forEach(el => obs.observe(el));
  })();

  /* ─── Multi-speed parallax ─── */
  (function initMultiParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = $$('[data-parallax-speed]');
    if (!els.length) return;

    const update = () => {
      els.forEach(el => {
        const rect  = el.getBoundingClientRect();
        const speed = parseFloat(el.dataset.parallaxSpeed) || 0.2;
        const mid   = rect.top + rect.height / 2 - window.innerHeight / 2;
        el.style.transform = `translateY(${mid * speed}px)`;
      });
    };

    on(window, 'scroll', update, { passive: true });
    update();
  })();

  /* ─── Magnetic CTA buttons ─── */
  (function initMagnetic() {
    if ('ontouchstart' in window) return;
    $$('[data-magnetic]').forEach(btn => {
      on(btn, 'mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width  / 2) * 0.25;
        const y = (e.clientY - r.top  - r.height / 2) * 0.25;
        btn.style.transform  = `translate(${x}px, ${y}px)`;
        btn.style.transition = 'transform 0.2s ease';
      });
      on(btn, 'mouseleave', () => {
        btn.style.transform  = 'translate(0,0)';
        btn.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      });
    });
  })();

  /* ─── Scent modal (scents page) ─── */
  (function initScentModal() {
    const modals = $$('.scent-modal');
    if (modals.length === 0) return;

    const overlay = $('#overlay');
    const openers = $$('[data-scent-open]');
    let activeModal = null;
    let lastFocused = null;

    const FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

    function trapFocus(e) {
      if (!activeModal) return;

      if (e.key === 'Escape') {
        close();
        return;
      }

      if (e.key !== 'Tab') return;

      const items = $$(FOCUSABLE, activeModal);
      if (items.length === 0) return;

      const first = items[0];
      const last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open(id) {
      const modal = $(`.scent-modal[data-scent-modal="${id}"]`);
      if (!modal) return;

      lastFocused = document.activeElement;
      activeModal = modal;

      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      overlay && overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      const closeBtn = $('[data-scent-close]', modal);
      closeBtn && closeBtn.focus();

      on(document, 'keydown', trapFocus);
    }

    function close() {
      if (!activeModal) return;

      activeModal.classList.remove('open');
      activeModal.setAttribute('aria-hidden', 'true');
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';

      off(document, 'keydown', trapFocus);

      lastFocused && lastFocused.focus();
      activeModal = null;
    }

    openers.forEach(btn => on(btn, 'click', () => open(btn.dataset.scentOpen)));
    modals.forEach(modal => {
      $$('[data-scent-close]', modal).forEach(btn => on(btn, 'click', close));
    });

    on(overlay, 'click', () => { if (activeModal) close(); });
  })();

})();
